import { client } from "@/api/config";
import {
  ContentItem,
  PagedPublishedContentItemsRequest,
} from "@/types/api/audience-content-item.types";
import { AudienceContentItem } from "@/types/api/open-letter.types";
import { PagedResult } from "@/types/api/shared.types";

export const AudienceContentItemService = {
  getAudienceContentItems: async (
    params: AudienceContentItem,
  ): Promise<ContentItem[]> => {
    const response = await client.get<{ items: ContentItem[] }>(
      "/audience-content-item/published-content-items",
      {
        paramsSerializer: (params) => new URLSearchParams(params).toString(),
        params,
      },
    );

    return response.data.items;
  },

  getPagedPublishedContentItems: async (
    params: PagedPublishedContentItemsRequest,
    signal: AbortSignal,
  ): Promise<PagedResult<ContentItem>> => {
    const response = await client.get<PagedResult<ContentItem>>(
      "/audience-content-item/paginated-published-content-items",
      {
        paramsSerializer: (params) => new URLSearchParams(params).toString(),
        params,
        signal,
      },
    );

    return response.data;
  },
};
